import dayjs from "dayjs";
import { wilsonScoreInterval } from "@/utils/number";

export type ChartData = {
  date: string;
  timestamp?: number;
  notCompleted: boolean;
  crawledRate: number | null;
  indexedRate: number | null;
  sevenDaysMovingAverageCrawledRate: number | null;
  sevenDaysMovingAverageIndexedRate: number | null;
  twentyEightDaysMovingAverageCrawledRate: number | null;
  twentyEightDaysMovingAverageIndexedRate: number | null;
  crawledCi: [number, number] | null;
  indexedCi: [number, number] | null;
};

type IndexWorkerJobEdge = {
  node: {
    id: string;
    __typename: "IndexWorkerJob";
    createdAt: string;
    completedAt: string | null;
    requestCount: number;
    failureCount: number;
    result: {
      indexedRate: number;
      crawledRate: number;
      sevenDaysMovingAverageCrawledRate: number;
      sevenDaysMovingAverageIndexedRate: number;
      twentyEightDaysMovingAverageCrawledRate: number;
      twentyEightDaysMovingAverageIndexedRate: number;
      crawledCount: number;
      indexedCount: number;
      totalCount: number;
    } | null;
  };
};

export function generateChartData(edges: IndexWorkerJobEdge[]): ChartData[] {
  const processedEdges = edges.toReversed().map((edge) => {
    const result = edge.node.result;
    const notCompleted = edge.node.completedAt === null;

    const date = dayjs(edge.node.createdAt).format("YYYY-MM-DD");

    return {
      date,
      timestamp: Date.parse(`${date}T00:00:00.000Z`),
      crawledRate: notCompleted ? null : (result?.crawledRate ?? 0),
      indexedRate: notCompleted ? null : (result?.indexedRate ?? 0),
      sevenDaysMovingAverageCrawledRate: notCompleted
        ? null
        : (result?.sevenDaysMovingAverageCrawledRate ?? 0),
      sevenDaysMovingAverageIndexedRate: notCompleted
        ? null
        : (result?.sevenDaysMovingAverageIndexedRate ?? 0),
      twentyEightDaysMovingAverageCrawledRate: notCompleted
        ? null
        : (result?.twentyEightDaysMovingAverageCrawledRate ?? 0),
      twentyEightDaysMovingAverageIndexedRate: notCompleted
        ? null
        : (result?.twentyEightDaysMovingAverageIndexedRate ?? 0),
      crawledCi: notCompleted
        ? null
        : result
          ? wilsonScoreInterval(result.crawledCount, result.totalCount)
          : null,
      indexedCi: notCompleted
        ? null
        : result
          ? wilsonScoreInterval(result.indexedCount, result.totalCount)
          : null,
      notCompleted,
    };
  });

  // 同一日付のデータは最新のものだけ採用
  // processedEdgesは古い→新しいの順なので、後から来たもので上書き
  const uniqueEdgesMap = new Map<string, (typeof processedEdges)[0]>();
  for (const edge of processedEdges) {
    uniqueEdgesMap.set(edge.date, edge);
  }
  const uniqueEdges = Array.from(uniqueEdgesMap.values());
  return uniqueEdges;
}
